// The tools shown in the Data Toolkit left nav. `hidden: true` keeps a tool's
// code in place but leaves it out of the nav and routing (Data Magic is hidden
// pending fixes; flip the flag to bring it back).
export const TOOLKIT_TOOLS = [
  {
    key: "find-email",
    title: "Find email",
    desc: "Find verified work emails from a name and company, or a LinkedIn URL.",
    icon: "alternate_email",
    path: "/data-toolkit/find-email",
    available: true
  },
  {
    key: "validate",
    title: "Validate emails",
    desc: "Check whether a list of emails is deliverable, risky or invalid.",
    icon: "verified",
    path: "/data-toolkit/validate",
    available: true
  },
  {
    key: "enrich-contacts",
    title: "Enrich contacts",
    desc: "Enrich people from a LinkedIn URL, or a name and company.",
    icon: "person_search",
    path: "/data-toolkit/enrich-contacts",
    available: true
  },
  {
    key: "enrich-accounts",
    title: "Enrich accounts",
    desc: "Enrich companies from a website or company LinkedIn URL.",
    icon: "domain",
    path: "/data-toolkit/enrich-accounts",
    available: true
  },
  {
    key: "data-magic",
    title: "Data magic",
    desc: "Paste any data. We clean it up, find what's missing and enrich it.",
    icon: "auto_fix_high",
    path: "/data-toolkit/data-magic",
    available: true,
    // Hidden for now — released with the other tools once its pricing and the
    // moved-contact flow are finalized.
    hidden: true
  }
];

// Field targets for the Find-email column mapping step. `key` matches the
// backend FindEmailRequest.mapping keys; `match` are header substrings used to
// auto-guess the mapping.
// Order matters: more specific fields claim columns first during auto-map, so
// "First Name" is never grabbed by the generic "name" token of Full name.
export const FIND_EMAIL_FIELDS = [
  { key: "firstName", label: "First name", match: ["first name", "firstname", "first", "fname", "given name"] },
  { key: "lastName", label: "Last name", match: ["last name", "lastname", "last", "lname", "surname", "family name"] },
  { key: "companyDomain", label: "Company domain", match: ["company domain", "domain", "website", "web site", "url", "site"] },
  { key: "companyName", label: "Company name", match: ["company name", "company", "organization", "organisation", "employer", "account name"] },
  { key: "linkedinUrl", label: "LinkedIn URL", match: ["linkedin url", "linkedin", "li url", "profile url"] },
  { key: "fullName", label: "Full name", match: ["full name", "fullname", "contact name", "name"] }
];

// Field target for the Validate-emails column mapping (just the email column).
export const VALIDATE_EMAIL_FIELDS = [
  { key: "email", label: "Email", match: ["email address", "email", "e-mail", "mail", "work email"] }
];

// Field targets for Enrich contacts: a LinkedIn URL, or a name + company.
// Order matters for auto-map (specific fields claim their column first).
export const ENRICH_CONTACT_FIELDS = [
  { key: "firstName", label: "First name", match: ["first name", "firstname", "first", "fname", "given name"] },
  { key: "lastName", label: "Last name", match: ["last name", "lastname", "last", "lname", "surname", "family name"] },
  { key: "companyDomain", label: "Company domain", match: ["company domain", "domain", "website", "web site", "url", "site"] },
  { key: "companyName", label: "Company name", match: ["company name", "company", "organization", "organisation", "employer", "account name"] },
  { key: "linkedinUrl", label: "LinkedIn URL", match: ["linkedin url", "linkedin", "li url", "profile url"] },
  { key: "fullName", label: "Full name", match: ["full name", "fullname", "contact name", "name"] }
];

// Field targets for Enrich accounts: a website/domain, or a company LinkedIn URL.
export const ENRICH_ACCOUNT_FIELDS = [
  { key: "companyLinkedin", label: "Company LinkedIn URL", match: ["company linkedin url", "company linkedin", "linkedin url", "linkedin", "li url", "company url"] },
  { key: "companyDomain", label: "Website / domain", match: ["company website", "website", "web site", "company domain", "domain", "url", "site"] }
];

// Field targets for Data Magic: any identifier we can act on (person or company).
export const MAGIC_FIELDS = [
  { key: "firstName", label: "First name", match: ["first name", "firstname", "first", "fname", "given name"] },
  { key: "lastName", label: "Last name", match: ["last name", "lastname", "last", "lname", "surname", "family name"] },
  { key: "email", label: "Email", match: ["email address", "email", "e-mail", "mail", "work email"] },
  { key: "linkedinUrl", label: "LinkedIn URL", match: ["linkedin profile", "linkedin url", "linkedin", "profile url"] },
  { key: "companyLinkedin", label: "Company LinkedIn URL", match: ["company linkedin", "company linkedin url"] },
  { key: "companyDomain", label: "Website / domain", match: ["company website", "website", "web site", "company domain", "domain", "email domain", "url", "site"] },
  { key: "companyName", label: "Company name", match: ["company / account", "company name", "company", "account", "organization", "organisation", "employer"] },
  { key: "fullName", label: "Full name", match: ["full name", "fullname", "contact name", "name"] }
];

// Poll interval (ms) while a job is running.
export const POLL_INTERVAL_MS = 4000;

// Upper bound on rows per run (mirrors backend DataToolkitConstants.MAX_INPUT_ROWS).
export const MAX_INPUT_ROWS = 50000;

// In-app results preview cap (mirrors backend DataToolkitConstants.VIEW_RESULT_LIMIT).
export const VIEW_RESULT_LIMIT = 10;
